module.exports = __webpack_public_path__ + "static/media/1-foundations-value-grayscale.2f480c27.jpg";